import { Action } from '@ngrx/store';
import { StatusMessage } from '@app/store/layout/layout.model';

export const TOGGLE_SIDEBAR_VIEW = 'TOGGLE_SIDEBAR_VIEW';
export const MOVE_STEPPER_FORWARD = 'MOVE_STEPPER_FORWARD';
export const MOVE_STEPPER_BACKWARD = 'MOVE_STEPPER_BACKWARD';
export const RESET_STEPPER_POSITION = 'RESET_STEPPER_POSITION';
export const TOGGLE_SAMPLE_TYPE_SELECTOR_POPUP = 'TOGGLE_SAMPLE_TYPE_SELECTOR_POPUP';
export const SET_SAMPLING_SUPPLIES_SCROLL_TOP = 'LAYOUT: SAMPLING SUPPLIES: SET SCROLL TOP';
export const SET_SAMPLING_SUPPLIES_ACCORDION_EXPANDING = 'LAYOUT: SAMPLING SUPPLIES: SET ACCORDION EXPANDING';
export const SET_SAMPLING_SUPPLIES_QUANTITY_ERROR = 'SET_SAMPLING_SUPPLIES_QUANTITY_ERROR';
export const LOAD_STATUS_MESSAGE = 'LOAD_STATUS_MESSAGE';
export const SET_STATUS_MESSAGE = 'SET_STATUS_MESSAGE';

export class ToggleSidebarView implements Action {
    readonly type = TOGGLE_SIDEBAR_VIEW;

    constructor(public toggleSidebarView: boolean) {
    }
}

export class MoveStepperForward implements Action {
    readonly type = MOVE_STEPPER_FORWARD;

    constructor() {
    }
}

export class MoveStepperBackward implements Action {
    readonly type = MOVE_STEPPER_BACKWARD;

    constructor() {
    }
}

export class ResetStepperPosition implements Action {
    readonly type = RESET_STEPPER_POSITION;

    constructor() {
    }
}

export class ToggleSampleTypeSelectorPopup implements Action {
    readonly type = TOGGLE_SAMPLE_TYPE_SELECTOR_POPUP;

    constructor(public toggleSampleTypeSelectorPopup: boolean) {
    }
}


export class SetSamplingSuppliesScrollTop implements Action {
    readonly type = SET_SAMPLING_SUPPLIES_SCROLL_TOP;

    constructor(public pixels: number) {
    }
}

export class SetSamplingSuppliesAccordionExpanding implements Action {
    readonly type = SET_SAMPLING_SUPPLIES_ACCORDION_EXPANDING;

    constructor(public expanding: boolean) {
    }
}

export class SetSamplingSuppliesQuantityError implements Action {
    readonly type = SET_SAMPLING_SUPPLIES_QUANTITY_ERROR;

    constructor(public isQuantityError: boolean) {

    }
}

export class LoadStatusMessage implements Action {
    readonly type = LOAD_STATUS_MESSAGE;

    constructor() {
    }
}

export class SetStatusMessage implements Action {
    readonly type = SET_STATUS_MESSAGE;

    constructor(public statusMessage: StatusMessage) {
    }
}

export type LayoutActions = ToggleSidebarView |
MoveStepperForward | MoveStepperBackward | ResetStepperPosition |
ToggleSampleTypeSelectorPopup |
SetSamplingSuppliesScrollTop | SetSamplingSuppliesAccordionExpanding | SetSamplingSuppliesQuantityError | LoadStatusMessage |
SetStatusMessage;
